/**
 * 获取支付方式工具类
 *
 * @author terrfly
 * @site https://www.jeepay.vip
 * @date 2021/5/8 07:18
 */

import config from '@/config'

const getToPageRouteName = function () {
    const payWay = getPayWay();
    return  payWay? payWay.routeName : null
}

/**
 * 优先从 URL 中读取支付方式（支持 Stripe 等非浏览器UA识别的渠道）
 * 例如： #/cashier/stripe?wayCode=STRIPE_ONE&token=xxx
 */
const getUrlWayCode = function () {
    const hash = window.location.hash || '';
    const queryIndex = hash.indexOf('?');
    if(queryIndex < 0) {
        return null;
    }
    const queryStr = hash.substring(queryIndex + 1);
    const params = new URLSearchParams(queryStr);
    const wayCode = params.get('wayCode');
    // 收银台仅支持 Stripe 一次性支付（订阅请走 API 传 channelExtra）
    if(wayCode === 'STRIPE_ONE'){
        return 'STRIPE';
    }
    return null;
}

const getPayWay = function () {

    // 1. URL 携带的 wayCode 优先（Stripe 卡片支付等）
    const urlWay = getUrlWayCode();
    if(urlWay){
        return config.payWay[urlWay];
    }

    // 2. 根据 userAgent 识别微信/支付宝
    const userAgent = navigator.userAgent;

    if(userAgent.indexOf("MicroMessenger") >= 0){
        return config.payWay.WXPAY;
    }

    if(userAgent.indexOf("AlipayClient") >= 0){
        return config.payWay.ALIPAY;
    }

    return null;

}


export default { getToPageRouteName: getToPageRouteName,
    getPayWay: getPayWay

}
